module.exports = __webpack_public_path__ + "vue/img/upload-01.99d61065.png";